import { UIButton, UIText, UIToggle } from "../types";

export const EMPTY_UI_TEXT: UIText = {
  value: "",
};

export const EMPTY_UI_BUTTON: UIButton = {
  label: EMPTY_UI_TEXT,
};

export const EMPTY_UI_TOGGLE: UIToggle = {
  label: EMPTY_UI_TEXT,
};
